import React, { useState, useEffect } from 'react';
import { Row, Col} from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import ListeEquipe from './listeEquipe';
import InfoEquipe from './infoEquipe';




const EquipeVisiteur = () => {

  const [equipe,setEquipe] = useState()
  const [selectedTeam, setSelectedTeam] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const Navigate = useNavigate();
  const apiUrl = process.env.REACT_APP_API_URL;

  


  useEffect(() => {
    setIsLoading(true)
    const fetchData = async () => {
        try {
          const response = await axios.get(
            `${apiUrl}/recherche/equipe-visiteur`
          );
        setEquipe(response.data);
        setIsLoading(false)

        
      } catch (error) {
        Navigate('/')

      }
    };

    fetchData(); 
  }, [Navigate, apiUrl]);  

  const handleTeamClick = (team) => {
    setSelectedTeam(team);
  };

  if (isLoading) {

    return (
    <div className="centered-content">
      <img src="/img/logo.png" alt="Logo" className="centered-logo" />
      <br/>
      <span className="loader"></span>
    </div>
    
    );  
  }

  return (
    <>
        {equipe && 
        <Row style={{margin:'5%'}}>
            <Col md={4}>
            <h4>Les équipes qui utilisent FootProManager </h4>
            <ListeEquipe teams={equipe} onTeamClick={handleTeamClick} />
            </Col>
            <Col md={8}>
            {selectedTeam ? (
                <InfoEquipe team={selectedTeam} equipe={equipe}/>
            ) : (
                <p>Sélectionnez une équipe pour voir les détails de ses matchs et son classement.</p>
            )}
            </Col>
        </Row>
            } 
    </>    
  );
};

export default EquipeVisiteur;
